// extracted by mini-css-extract-plugin
export default {"image":"e4-z","loaded":"f4-z"};